import { ClipboardList, MessagesSquare, Workflow } from 'lucide-react';

/*
 * How the consultants work through the rules with a team: Inform, Plan,
 * Implement. The Consulting page draws them as its path
 * (Consulting/EngagementPath) and Home's consulting band lists them
 * (Welcome/Consulting), so they live here, outside both pages' folders: one
 * page's section module imported into another page would pull it into that
 * page's chunks. Their copy is `site.consulting.path.<stage>.title` and
 * `.text`.
 */

/** The three stages, in order; each verb is its own label. */
export const STAGES = Object.freeze(['inform', 'plan', 'implement']);

/** Each stage's icon. */
export const ICONS = Object.freeze({ inform: MessagesSquare, plan: ClipboardList, implement: Workflow });
